module.exports = __webpack_public_path__ + "static/media/img_apple_store.46a1566b.svg";